module.exports = __webpack_public_path__ + "img/img-bio-protection.35dc6324.svg";